import { EditableSettingProperty } from "@/enums/editables";
import rgbToHex from "hoxton-shared/utils/rgbToHex";
import { kebabCase } from "lodash";

const cssProperties = {
    [EditableSettingProperty.FontColor]: "color",
    [EditableSettingProperty.Scale]: "transform"
};

export default function getDomValue(
    computedStyle: CSSStyleDeclaration | undefined,
    property: string,
    boundingClientRect?: DOMRect
) {
    if (!computedStyle || Object.keys(computedStyle).length === 0) {
        return;
    }

    const cssProperty = cssProperties[property as keyof typeof cssProperties] || kebabCase(property);
    const value = computedStyle.getPropertyValue(cssProperty);

    if (!value) {
        return;
    }

    switch (property) {
        case EditableSettingProperty.Height:
        case EditableSettingProperty.Width: {
            const numericValue = Number.parseFloat(value);

            if (Number.isNaN(numericValue) && boundingClientRect instanceof DOMRect && boundingClientRect[property]) {
                return `${boundingClientRect[property]}px`;
            } else {
                return `${numericValue.toFixed(0)}px`;
            }
        }
        case EditableSettingProperty.FontColor: {
            if (value.startsWith("rgb(")) {
                const sep = value.includes(",") ? "," : " ";
                const rgb = value.slice(4).split(")")[0]!.split(sep);

                const r = parseInt(rgb[0]!, 10);
                const g = parseInt(rgb[1]!, 10);
                const b = parseInt(rgb[2]!, 10);

                return rgbToHex(r, g, b);
            }

            return value;
        }
        case EditableSettingProperty.Scale: {
            const scaleRegex = /scale\([^)]*\)(;|)?/;
            const cssValue = scaleRegex.exec(value)?.[0];

            if (cssValue?.includes(",")) {
                const firstValue = cssValue.split(",")[0];
                return (parseFloat(firstValue!) * 100).toString();
            }

            return cssValue ? (parseFloat(cssValue[0]!) * 100).toString() : "100";
        }

        default:
            return value;
    }
}
